module.exports = __webpack_public_path__ + "static/media/cadena3.a8bc6188.svg";